import React, { useState } from 'react'
import styles from './BannerItem.module.scss';

const BannerItem = (props) => {

  const [openPlatforms, setOpenPlatforms] = useState(false);

  const onClickBanner = (platforms) => {

    const length = Object.keys(platforms).length;
  
    if (length == 0){
      return;
    }
    else if (length == 1){
      window.open(platforms[Object.keys(platforms)[0]], '_blank');
    }
    else{
      setOpenPlatforms(!openPlatforms);
    }
  }

  if (props.isLocked) {
    return (
      <div id={styles.wrapper_banner}>
        <div className={styles.container_img}>
          <div className={styles.lock_img} />
        </div>

        <div className={styles.wrapper_content}>
          <div className={styles.content}>
            <p className={styles.title} style={{ opacity: '0.5' }}>{props.title}</p>
            <p className={styles.detail}>{props.detail}</p>
          </div>
        </div>

        {/* <div className={styles.overlay}/> */}
      </div>
    )
  }

  if (props.orientation === 'portrait') {
    return '';
  }

  if (props.orientation === 'landscape') {
    return (
      <div id={styles.wrapper_banner} onMouseLeave={() => {setOpenPlatforms(false);}}>

        <div className={styles.click_box} onClick={() => { onClickBanner(props.platforms); }}>
          <div className={styles.container_img}>
            <img src={props.imgUrl} alt='img' />
          </div>
          <div className={styles.wrapper_content}>
            <div className={styles.content}>
              <p className={styles.title}>{props.title}</p>
              <p className={styles.detail}>{props.detail}</p>
              <div className={styles.platform_list}>
                {
                  Object.keys(props.platforms).map((platform, key) => (
                    platform === 'android' ? <div className={styles.android} /> :
                    platform === 'iOS' && <div className={styles.iOS} />
                  ))
                }
              </div>
            </div>
          </div>
        </div>

        {openPlatforms && 
          <div className={styles.overlay} onClick={() => {setOpenPlatforms(false); }}>
            <div className={styles.platform_container}>
            {
                  Object.keys(props.platforms).map((platform, key) => ( 
                    <div className={styles.platform_box} onClick={()=>{
                      setTimeout(() => {
                        window.open(props.platforms[platform], '_blank')
                      }, 70)}}>
                      <div className={platform === 'android' ? styles.gpgs : platform === 'iOS' && styles.appstore}/>
                      <p>{platform === 'android' ? 'Google Play Store' : platform === 'iOS' && 'App Store'}</p>
                    </div>
                  ))
                }
            </div>
          </div>
        
        }

        
      </div>
    )
  }

}

export default BannerItem;